"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopLegendHeader = exports.TopLegend = exports.ColumnHeader = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../helpers");
const StackView_1 = require("../StackView");
const helpers_2 = require("./helpers");
const HoursLegendHeader_1 = require("./HoursLegendHeader");
const ColumnHeaderRoot = (0, styled_components_1.default)(StackView_1.StackView) `
    height: ${helpers_1.SIZE_L};
`;
exports.ColumnHeader = (0, helpers_1.createUIElement)('ColumnHeader', (_a, ref) => {
    var { className, children, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "children", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (react_1.default.createElement(ColumnHeaderRoot, Object.assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: `vm-ColumnHeader ${className}`, root: true, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }), children));
});
exports.TopLegend = (0, styled_components_1.default)(StackView_1.StackView) `
    position: absolute;
    top: -${24 + 4}px;
    left: -4px;
    right: -4px;
    ${exports.ColumnHeader.selector} {
        // TODO: use theme after theme refactoring and add helpers for this (spacing.xxl + spacing.s)
        width: ${({ tileSize }) => `calc(${(0, helpers_2.calcTileWidth)(tileSize)} + 8px)`};
    }
`;
exports.TopLegendHeader = (0, styled_components_1.default)(StackView_1.StackView) `
    position: absolute;
    top: -${24 + 4 + 16 + 8}px;

    ${HoursLegendHeader_1.SunIcon} {
        width: ${({ sunIconSize }) => (0, helpers_2.calcTileWidth)(sunIconSize)};
    }

    ${({ sideOffset }) => (0, styled_components_1.css) `
            left: calc(4px - ${sideOffset}px);
            right: calc(4px - ${sideOffset}px);
        `}

    ${({ sunIconPosition }) => {
    if (sunIconPosition === helpers_2.SUN_ICON_POSITION.firstColumn) {
        return (0, styled_components_1.css) `
                ${HoursLegendHeader_1.FirstMoonIcon} {
                    display: none;
                }

                ${HoursLegendHeader_1.AMText} {
                    width: 0;
                    overflow: hidden;
                    padding-left: 0;
                }
            `;
    }
    if (sunIconPosition === helpers_2.SUN_ICON_POSITION.lastColumn) {
        return (0, styled_components_1.css) `
                ${HoursLegendHeader_1.SecondMoonIcon}, ${HoursLegendHeader_1.PMText} {
                    display: none;
                }
            `;
    }
    return (0, styled_components_1.css) ``;
}}

    ${({ rowIndexForSunIcon, sideOffset, sunIconSize }) => rowIndexForSunIcon &&
    (0, styled_components_1.css) `
            ${HoursLegendHeader_1.AMText} {
                width: ${(0, helpers_2.getMarginLeftSunIcon)({
        rowIndexForSunIcon,
        sideOffset,
        tileSize: sunIconSize
    })}px;
                flex-shrink: 0;
            }
        `}
`;
//# sourceMappingURL=TopLegend.js.map